<template>
	<!-- BEGIN login -->
	<div class="login login-with-news-feed">
		<!-- BEGIN news-feed -->
		<div class="news-feed">
			<div class="news-image" style="background-image: url(/assets/img/login-bg/loginback.jpg)"></div>
			<div class="news-caption">
				<h4 class="caption-title"><b>Report</b> Admin v2.0</h4>
			</div>
		</div>
		<!-- END news-feed -->
		
		<!-- BEGIN login-container -->
		<div class="login-container">
			<!-- BEGIN login-header -->
			<div class="login-header mb-30px">
				<div class="brand">
					<div class="d-flex align-items-center">
						<span class="logo"></span>
						<b>Report</b>&nbsp;Admin&nbsp;<b>v2</b>
					</div>
					<small>Enter login and password to continue.</small>
				</div>
				<div class="icon">
					<i class="fa fa-sign-in-alt"></i>
				</div>
			</div>
			<!-- END login-header -->
			
			<!-- BEGIN login-content -->
			<div class="login-content">
				<form v-on:submit="checkForm" method="GET" class="fs-13px">
					<div class="form-floating mb-15px">
						<input type="text" class="form-control h-45px fs-13px" placeholder="Username" id="username" v-model="username" />
						<label for="username" class="d-flex align-items-center fs-13px text-gray-600">Username</label>
					</div>
					<div class="form-floating mb-15px">
						<input type="password" class="form-control h-45px fs-13px" placeholder="Password" id="password" v-model="password" />
						<label for="password" class="d-flex align-items-center fs-13px text-gray-600">Password</label>
					</div>
					<div class="form-check mb-30px">
						<input class="form-check-input" type="checkbox" value="1" id="rememberMe" checked />
						<label class="form-check-label" for="rememberMe">
							Remember Me
						</label>
					</div>
					<div class="mb-15px">
						<button type="submit" class="btn btn-primary d-block h-45px w-100 btn-lg fs-14px">SIGN IN</button>
					</div>
					<hr class="bg-gray-600 opacity-2" />
					<div class="text-gray-600 text-center text-gray-500-darker mb-0">
						Report Admin v2 &copy; 2022 - 7Thunders Publishing
					</div>
				</form>
			</div>
			<!-- END login-content -->
		</div>
		<!-- END login-container -->
	</div>
	<!-- END login -->
</template>

<script>
import AppOptions from '../config/AppOptions.vue'
import { useCookies } from "vue3-cookies";

export default {
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
	created() {
		AppOptions.appEmpty = true;
	},
  data()
  {
      return {
    username: '',
    password: ''
    }
  },
	beforeRouteLeave (to, from, next) {
		AppOptions.appEmpty = false;
		next();
	},
	methods: {
		checkForm: function(e) {
			e.preventDefault();
      const crypto = require('crypto');
      const secret = 'GASEWkjshga@asdjfhasdfAA!fcaf@gdh#asdA';
      const hash = crypto.createHmac('sha256', secret)
                    .update(this.password)
                    .digest('hex');

      if (this.username !== 'admin' || hash !== 'b8d32bd79ea384bb101f69e0935ee9c87be516c6642e39a479bf417b16354b2e')
      {
        this.$swal.fire('Access Denied', 'You entered an incorrect login or password.', 'error');
      }
      else
      {
        this.cookies.set("username", this.username);
        this.cookies.set("authenticated", this.password);
        this.$router.push('/dashboard/')
      }
		}
	}
}
</script>